import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SmartLink } from 'components/SmartLink';
import { ServiceOffering } from 'olo-service';
import { Icon } from 'components/Icon';
import { getCurrentHours } from 'hooks/context/merchant/util';
import { SERVICE_HOURS_TEST_ID } from 'routes/Menu/BusinessInfo/ServiceHours/const';
import { SERVICE_HOURS_MODAL_ID } from 'routes/Menu/BusinessInfo/ServiceHours/Modal/ServiceHoursModal';

import styles from './index.module.scss';

type ServiceHoursProps = {
  service: ServiceOffering;
  timezone: string;
  className?: string;
};

export const ServiceHours: React.FC<ServiceHoursProps> = ({ service, timezone, className }) => {
  const { t } = useTranslation();
  const currentHours = getCurrentHours(timezone, service);

  return (
    <SmartLink to={`~${SERVICE_HOURS_MODAL_ID}`} className={clsx(styles.hours, className)} data-testid={SERVICE_HOURS_TEST_ID.root}>
      <Icon name={'clock'} size={13} />
      <p>
        {!!currentHours && (
          <>
            <span className={styles.bold}>{t('open')}</span>
            &nbsp;
            <span className={clsx(styles.secondaryText)}>{t('hoursWithPrepositions', currentHours)}</span>
          </>
        )}
        {!currentHours && <span className={styles.bold}>{t('closed')}</span>}
      </p>
      <Icon name={'expand'} size={20} />
    </SmartLink>
  );
};
